const AUTH_MODES = {
  LEGACY: "LEGACY",
  HYBRID: "HYBRID",
  SSO: "SSO"
};
const validateComponentUsage = ({
  mode,
  children,
  LoadingComponent,
  checkValidSovosIdentity,
  auth,
  hasAuthParams
}) => {
  if (!auth && mode !== AUTH_MODES.LEGACY) {
    throw new Error(`Invalid usage. While using HYBRID/SSO mode, this component needs to be wrapped by <AuthProvider/>`);
  }
  if (!hasAuthParams && mode !== AUTH_MODES.LEGACY) {
    throw new Error(`Invalid usage. hasAuthParams is ${hasAuthParams}, this component needs to be wrapped by <AuthProvider/> and given the hasAuthParams function from react-oidc-context`);
  }
  if (mode && !Object.values(AUTH_MODES).includes(mode)) {
    throw new Error(`Invalid mode. ${mode} was used. Available modes: ${Object.values(AUTH_MODES)}`);
  }
  if (mode && mode !== AUTH_MODES.SSO && !children) {
    throw new Error(`Invalid usage. ${mode} mode was used but no Login component was provided as a child`);
  }
  if (!LoadingComponent && mode === AUTH_MODES.SSO) {
    throw new Error(`Invalid usage. Please define your loading component as a prop`);
  }
  if (mode === AUTH_MODES.HYBRID && !checkValidSovosIdentity) {
    throw new Error(`Invalid usage. Please define your checkValidSovosIdentity function as a prop for Hybrid mode`);
  }
};
const needsToBeRedirected = (hasAuthParams, auth, userInfo, mode, legacyLogin) => !hasAuthParams && !auth.isAuthenticated && !auth.activeNavigator && (userInfo || mode === AUTH_MODES.SSO) && !auth.isLoading && !legacyLogin && (mode === AUTH_MODES.HYBRID && userInfo && userInfo.hasUpgradedAccount || mode == AUTH_MODES.SSO);
const userWasLoggedOutOrExpired = (hasAuthParams, auth, userInfo, legacyLogin, onUserLogOut) => !hasAuthParams && !auth.isLoading && !auth.activeNavigator && auth.isAuthenticated && !userInfo && !legacyLogin && onUserLogOut;
const logOutUser = auth => auth && auth.activeNavigator === "signinRedirect" && !auth.isLoading && !auth.isAuthenticated;
const userIsAuthenticated = (auth, onUserAuthenticated) => !auth.isLoading && auth.isAuthenticated && onUserAuthenticated;
export { AUTH_MODES, logOutUser, userIsAuthenticated, userWasLoggedOutOrExpired, needsToBeRedirected, validateComponentUsage };